var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreferencesNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.422,
    height: 35.422,
    viewBox: "0 0 35.422 35.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47901-2",
    "data-name": "Group 47901"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55056",
    "data-name": "Path 55056",
    d: "M63.27,29.3c-3.809-1.72-3.954-9.1-3.957-9.291V15.056A11.529,11.529,0,0,0,52.259,4.443a4.458,4.458,0,0,0-8.917,0,11.529,11.529,0,0,0-7.053,10.613v4.954c0,.186-.148,7.57-3.957,9.291a1.011,1.011,0,0,0,.416,1.932h9.657a5.681,5.681,0,0,0,1.5,2.923,5.333,5.333,0,0,0,7.79,0,5.68,5.68,0,0,0,1.5-2.923h9.657A1.011,1.011,0,0,0,63.27,29.3Zm-5.018-3.537a11.21,11.21,0,0,0,1.772,3.448H35.578a11.209,11.209,0,0,0,1.771-3.448ZM47.8,2.022a2.441,2.441,0,0,1,2.341,1.762,11.562,11.562,0,0,0-4.683,0A2.441,2.441,0,0,1,47.8,2.022Zm-9.49,17.994v-4.96a9.49,9.49,0,0,1,18.98,0v4.968a21.1,21.1,0,0,0,.428,3.717H37.883A21.111,21.111,0,0,0,38.311,20.016ZM47.8,33.823a3.546,3.546,0,0,1-3.321-2.591h6.643A3.545,3.545,0,0,1,47.8,33.823Z",
    transform: "translate(-31.737)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55057",
    "data-name": "Path 55057",
    d: "M179.231,119.235a7.9,7.9,0,0,0-7.887,7.887,1.011,1.011,0,1,0,2.022,0,5.872,5.872,0,0,1,5.865-5.865,1.011,1.011,0,1,0,0-2.022Z",
    transform: "translate(-163.167 -112.251)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferencesNotifications);
export default __webpack_public_path__ + "static/media/preferences-notifications.9d8c4aeb3cb384995fd00c93963f2fb7.svg";
export { ForwardRef as ReactComponent };